import {
  calculateAllFinancialSupport,
  calculateFinancialSupport,
  toCurrency,
} from "../../../helpers";
import {
  ICourseListItemBackEndModel,
  ICourseListItemFrontEndModel,
} from "../types";
import { COURSE_HOUSING_TYPES_MAP, COURSE_TYPES_MAP } from "../constants";

export function parseCourseListItemToFrontEndModel(
  backEndModel: ICourseListItemBackEndModel,
): ICourseListItemFrontEndModel {
  const currency = backEndModel.currency;

  const ageRange = backEndModel.maxAge
    ? `${backEndModel.minAge} - ${backEndModel.maxAge}`
    : `${backEndModel.minAge} +`;

  const housingTypes = backEndModel.housingTypes.map(
    (type) => COURSE_HOUSING_TYPES_MAP[type],
  );

  const price = backEndModel.price;

  const commissionAmount = calculateFinancialSupport(
    price,
    true,
    backEndModel.commissionType,
    backEndModel.commissionAmount,
  );

  const priceDiscount = calculateFinancialSupport(
    price,
    backEndModel.hasPriceDiscount,
    backEndModel.priceDiscountType,
    backEndModel.priceDiscountAmount,
  );

  const otherFees = backEndModel.otherFees.reduce(
    (sum, fee) => sum + fee.amount,
    0,
  );

  const otherFeesDiscount = calculateFinancialSupport(
    otherFees,
    backEndModel.hasOtherFeesDiscount,
    backEndModel.otherFeesDiscountType,
    backEndModel.otherFeesDiscountAmount,
  );

  return {
    id: backEndModel.id,
    category: backEndModel.category,
    courseType: COURSE_TYPES_MAP[backEndModel.courseType],
    ageRange,
    housingTypes,
    isActive: backEndModel.isActive,
    finance: [
      {
        label: "Price",
        value: toCurrency(price, currency, " "),
      },
      {
        label: "Commission",
        value: toCurrency(commissionAmount, currency, " "),
      },
      {
        label: "Residence",
        value: toCurrency(backEndModel.residenceAmount, currency, " "),
      },
      {
        label: "Homestay",
        value: toCurrency(backEndModel.homestayAmount, currency, " "),
      },
      {
        label: "Insurance",
        value: toCurrency(backEndModel.insuranceAmount, currency, " "),
      },
      {
        label: "Other Fees",
        value: toCurrency(otherFees, currency, " "),
      },
      {
        label: "Discount",
        value: calculateAllFinancialSupport(
          priceDiscount,
          otherFeesDiscount,
          currency,
        ),
      },
    ],
  };
}
